import http from "../utils/api";

const assetTypeApi = 'assettypes';

const read = function(id) {
    return http.get(assetTypeApi + '/' + id);
};

export const assetTypeService = {
    read
};